// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"8752":"a9df574facac1c3b","9245":"3927bf677f62a837"}[chunkId] + ".css";
};